"use client"

import { Link, useNavigate } from "react-router-dom"
import { useTheme } from "../context/ThemeContext"
import { useAuth } from "../context/AuthContext"
import { useBlur } from '../context/BlurContext';
import { useSelector, useDispatch } from "react-redux"
import { performLogout } from "../redux/slices/authSlice"
import { switchMode } from "../redux/slices/modeSlice"
import { useTour } from "../hooks/useTour"


import ShieldIconSvg from '../assets/svg/ShieldIconSvg'
import { ChevronDown, EyeIcon, LockIcon, SunIcon } from "lucide-react"
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap"

function Header() {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const mode = useSelector(state => state.mode.mode);
  const switching = useSelector(state => state.mode.switching);
  const { theme, toggleTheme } = useTheme()
  const auth = useAuth()
  const { startTour } = useTour();

  console.log('Mode in header:', mode);

  const handleLogout = () => {
    // Dispatch optimistic logout (clears state and localStorage immediately)
    dispatch(performLogout());

    // Immediate navigation with replace to prevent back button access
    navigate("/login", { replace: true });
  }


  const getInitials = (name) => {
    return (
      name
        ?.split(" ")
        .map((n) => n[0])
        .join("") || "U"
    )
  }

  const onTogglePrivateMode = () => {
    if (!switching) {
      dispatch(switchMode());
    }
  }

  return (
    <>
      <header className="header">
        <div className="header-content">
          <div className="header-left">
            {/* <div className="icon-holder lg:hidden flex items-center header-button cursor-pointer" onClick={() => document.querySelector('body').classList.toggle('show-aside')}>
              <Menu size={20} />
            </div> */}
            <div className="lg:hidden flex items-center ms-2">
              <img width="150" src="/assets/kax-logo.svg" alt="kax-logo" />
            </div>

            <div className="private-mode-indicator hidden lg:flex">
              <span className="shield-icon">{mode === 'private' ? <LockIcon size={20} /> : <EyeIcon strokeWidth={1.5} />}</span>
              <div>
                <div className="indicator-title m-0">{mode === 'private' ? 'Show Private kaxaa wallet assets' : 'Show public kaxaa wallet assets'}</div>
                <div className="indicator-subtitle">Shielded token balances</div>
              </div>
            </div>
          </div>

          <div className="header-right">
            <button
              className="header-button px-2 md:flex hidden items-center gap-2 me-3 opacity-75 hover:opacity-100 transition-opacity"
              onClick={() => startTour()}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>
              <span className="text-14 fw-medium">Quick Tour</span>
            </button>


            <button
              id="tour-mode-switch"
              className={`me-lg-4 me-3 text-start ${switching ? 'opacity-75 cursor-not-allowed' : ''}`}
              onClick={onTogglePrivateMode}
              disabled={switching}
            >
              <div className="flex gap-2 items-center">
                {switching && (
                  <div className="toggle-spinner">
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}
                <label className={`toggle-switch ${switching ? 'switching' : ''}`}>
                  <input
                    type="checkbox"
                    checked={mode === 'private'}
                    onChange={onTogglePrivateMode}
                    disabled={switching}
                  />
                  <span className="toggle-slider"></span>

                </label>
                {/* <ShieldIconSvg /> */}
                <div className="min-w-[80px] fw-medium">
                  <p className="m-0 font-semibold" >{switching ? "Switching..." : (mode === 'private' ? "Private Mode" : "Public Mode")}</p>
                  <div className="connection-status text-12 lg:flex hidden font-normal">Connected to {mode === 'private' ? "private" : "public"} relayers</div>
                </div>
              </div>
            </button>


            {/* <div className="header-button text-start account-details">
            <div className="account-name">Account N1</div>
            <div className="account-subtitle">View wallets</div>
          </div> */}

            {/* <div>
          <select className="form-control header-button network-select m-0" style={{minWidth: '180px'}}>
            <option>Select Chain</option>
            <option>Polygon</option>
            <option>BSC</option>
          </select>
        </div> */}
            {/* <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-disabled"> {blurred ? "Show discretion" : "Blur discretion"}</Tooltip>}>
              <div
                onClick={handleClick}
                className="header-button flex items-center justify-center discretion-badge">
                {blurred ?
                  <div className="discretion-number text-center flex gap-1 justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M2.69 6.705a.75.75 0 0 0-1.38.59zm12.897 6.624l-.274-.698zm-6.546.409a.75.75 0 1 0-1.257-.818zm-2.67 1.353a.75.75 0 1 0 1.258.818zM22.69 7.295a.75.75 0 0 0-1.378-.59zM19 11.13l-.513-.547zm.97 2.03a.75.75 0 1 0 1.06-1.06zm-8.72 3.34a.75.75 0 0 0 1.5 0zm5.121-.591a.75.75 0 1 0 1.258-.818zm-10.84-4.25A.75.75 0 0 0 4.47 10.6zm-2.561.44a.75.75 0 0 0 1.06 1.06zM12 13.25c-3.224 0-5.539-1.605-7.075-3.26a13.6 13.6 0 0 1-1.702-2.28a12 12 0 0 1-.507-.946l-.022-.049l-.004-.01l-.001-.001L2 7l-.69.296h.001l.001.003l.003.006l.04.088q.039.088.117.243c.103.206.256.496.462.841c.41.69 1.035 1.61 1.891 2.533C5.54 12.855 8.224 14.75 12 14.75zm3.313-.62c-.97.383-2.071.62-3.313.62v1.5c1.438 0 2.725-.276 3.862-.723zm-7.529.29l-1.413 2.17l1.258.818l1.412-2.171zM22 7l-.69-.296h.001v.002l-.007.013l-.028.062a12 12 0 0 1-.64 1.162a13.3 13.3 0 0 1-2.15 2.639l1.027 1.094a14.8 14.8 0 0 0 3.122-4.26l.039-.085l.01-.024l.004-.007v-.003h.001v-.001zm-3.513 3.582c-.86.806-1.913 1.552-3.174 2.049l.549 1.396c1.473-.58 2.685-1.444 3.651-2.351zm-.017 1.077l1.5 1.5l1.06-1.06l-1.5-1.5zM11.25 14v2.5h1.5V14zm3.709-.262l1.412 2.171l1.258-.818l-1.413-2.171zm-10.49-3.14l-1.5 1.5L4.03 13.16l1.5-1.5z" /></svg>
                  </div>
                  :
                  <div className="discretion-number text-center flex gap-1 justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" d="M9 4.46A9.8 9.8 0 0 1 12 4c4.182 0 7.028 2.5 8.725 4.704C21.575 9.81 22 10.361 22 12c0 1.64-.425 2.191-1.275 3.296C19.028 17.5 16.182 20 12 20s-7.028-2.5-8.725-4.704C2.425 14.192 2 13.639 2 12c0-1.64.425-2.191 1.275-3.296A14.5 14.5 0 0 1 5 6.821" /><path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z" /></g></svg>
                  </div>
                }
              </div>
            </OverlayTrigger> */}
            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-disabled"> {theme === "dark" ? "Light mode" : "Dark mode"}</Tooltip>}>
              <button className="item header-button flex items-center justify-center" onClick={toggleTheme}>
                {theme === "dark" ? <SunIcon size={20} /> : <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="m21.067 11.857l-.642-.388zm-8.924-8.924l-.388-.642zM21.25 12A9.25 9.25 0 0 1 12 21.25v1.5c5.937 0 10.75-4.813 10.75-10.75zM12 21.25A9.25 9.25 0 0 1 2.75 12h-1.5c0 5.937 4.813 10.75 10.75 10.75zM2.75 12A9.25 9.25 0 0 1 12 2.75v-1.5C6.063 1.25 1.25 6.063 1.25 12zm12.75 2.25A5.75 5.75 0 0 1 9.75 8.5h-1.5a7.25 7.25 0 0 0 7.25 7.25zm4.925-2.781A5.75 5.75 0 0 1 15.5 14.25v1.5a7.25 7.25 0 0 0 6.21-3.505zM9.75 8.5a5.75 5.75 0 0 1 2.781-4.925l-.776-1.284A7.25 7.25 0 0 0 8.25 8.5zM12 2.75a.38.38 0 0 1-.268-.118a.3.3 0 0 1-.082-.155c-.004-.031-.002-.121.105-.186l.776 1.284c.503-.304.665-.861.606-1.299c-.062-.455-.42-1.026-1.137-1.026zm9.71 9.495c-.066.107-.156.109-.187.105a.3.3 0 0 1-.155-.082a.38.38 0 0 1-.118-.268h1.5c0-.717-.571-1.075-1.026-1.137c-.438-.059-.995.103-1.299.606z" /></svg>}
              </button>
            </OverlayTrigger>


            {/* <Dropdown className="profile-dropdown-container">
              <Dropdown.Toggle variant="" as={'div'} id="dropdown-basic" className="header-button profile-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10.268 21a2 2 0 0 0 3.464 0M22 8c0-2.3-.8-4.3-2-6M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326M4 2C2.8 3.7 2 5.7 2 8"/></svg>
                <span className="absolute -right-1 -top-1 p-1.5 bg-danger rounded-full"></span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="shadow rounded-3 dropdown-menu dropdown-menu-end overflow-y-auto w-100" style={{minWidth: '360px', maxWidth: '400px', maxHeight: '400px'}}>
                <Dropdown.Item href="#" className="p-0 border-bottom">
                  <div className="px-4 py-3">
                    <div className="flex items-center justify-between mb-1">
                      <h6 className="font-s m-0">POI completion</h6>
                      <span className="text-muted">12/12/25</span>
                    </div>
                    <p className="m-0 text-muted text-[13px] whitespace-normal">POI completion for Shield, Unshield and Private Transfer</p>
                  </div>
                </Dropdown.Item>
                    <p className="m-0 text-muted text-[13px] whitespace-normal">POI completion        <SummaryRow label="Transfer Type" value="Private Transfer" />
                  </div>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}

            <Dropdown className="profile-dropdown-container">
              <Dropdown.Toggle variant="" as={'div'} id="dropdown-basic" className="header-button profile-button">
                <div className="avatar">{getInitials(auth.user?.name)}</div>
                <span className="dropdown-arrow"><ChevronDown size={18} /> </span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="shadow rounded-3 dropdown-menu dropdown-menu-end">
                <div className="dropdown-header">
                  {/* <span className="hidden lg:block">My account</span> */}
                  <div className="profile-info">
                    <div className="profile-name">{auth.user?.name}</div>
                    <div className="profile-email">{auth.user?.email}</div>
                  </div>
                </div>
                <Dropdown.Item href="#" className="p-0"><Link to={'/reset-password'} className="dropdown-item flex items-center gap-1"> Reset Password </Link></Dropdown.Item>
                <Dropdown.Item href="/user-sessions"
                  className="dropdown-item flex items-center gap-1">User Sessions</Dropdown.Item>
                {/* <button className="dropdown-item flex  md:hidden" onClick={toggleTheme}>
                  {theme === "dark" ? 'Light mode' : 'Dark mode'}
                </button> */}
                <Dropdown.Item href="#" onClick={handleLogout} className="dropdown-item flex items-center gap-1 text-danger">Sign Out</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>


          </div>
        </div>
      </header >
    </>
  )
}

export default Header
